import api from './api';


export const userService = {

  getProfile: async () => {
    const response = await api.get('/users/profile');
    return response.data;
  },


  updateProfile: async (profileData) => {
    const response = await api.put('/users/profile', profileData);
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    const response = await api.put('/users/password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  uploadProfileImage: async (imageUrl) => {
    const response = await api.post('/users/profile-image', { imageUrl });
    return response.data;
  },
};

